import SocialIcons from './social-icons';

export default SocialIcons;